/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NonceResult { 
    /**
     * The nonce of the next transaction
     */
    nextNonce?: number;
}

